<app-header class="header-box" [sidebarSize]="sidebarSize"></app-header>
<app-course-preview [sidebarSize]="sidebarSize"></app-course-preview>